/**
 * The one "Find usages…" menu label, shared by every entry point.
 *
 * Decision D5 fixes this string byte-for-byte across the Object Explorer column
 * menu, BOTH results-grid header menus, and the Schema Overview drawer. Two
 * reasons it is a constant rather than four string literals:
 *
 * 1. The four surfaces are separate components (notably the two grids, which
 *    share no menu code at all) and would otherwise drift — "Find usages",
 *    "Find usages...", "Find Usages…" are all one careless keystroke away.
 * 2. `feat/new_autocomplete` adds its own, functionally different
 *    `'Find references…'` entry to `columnContextMenuService.ts`. That merge
 *    conflict is expected and routine; keeping OUR label pinned and identical
 *    is what makes it resolvable by keeping both entries rather than collapsing
 *    them (index-backed exact references vs. definition-text search).
 *
 * Note the character: U+2026 HORIZONTAL ELLIPSIS, not three periods.
 */
export const FIND_USAGES_MENU_LABEL = 'Find usages…';
